import { useParams } from 'react-router-dom';
import AuditHistory from '@/components/AuditHistory';
import { useGetUserByIdQuery, useGetUserLogsByIdQuery } from '@/services';

export default function UserLogs() {
    const { userId } = useParams<{ userId: string }>();
    const { data: user } = useGetUserByIdQuery(userId!, { skip: !userId });
    const { data, isLoading, error } = useGetUserLogsByIdQuery(userId!, { skip: !userId });

    return (
        <AuditHistory
            title="User History"
            entityName={user?.user?.name}
            backLink={{ to: '/users', label: 'Back to Users' }}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No user history found."
        />
    );
}
